import { Fragment } from "react"

import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import { Button } from "@progress/kendo-react-buttons"

import { Auth } from "aws-amplify"

function GoogleSignOn(props) {
  const materialUiTheme = useTheme()
  const sm = useMediaQuery(materialUiTheme.breakpoints.down("sm"))

  const {
    user,
    confirmDialogCreate,
    backgroundProcessor,
    disableResize,
    closeDrawer,
  } = props

  const onGoogleSignOnHandler = async () => {
    backgroundProcessor?.add()

    if (closeDrawer) closeDrawer()

    Auth.federatedSignIn({ provider: "Google" })

    backgroundProcessor?.remove()
  }

  const onGoogleSignOutHandler = async () => {
    if (closeDrawer) closeDrawer()

    confirmDialogCreate({
      title: "Sign Out",
      content: "Sign Out of the application?",
      onConfirm: async () => {
        backgroundProcessor?.add()

        await Auth.signOut()

        backgroundProcessor?.remove()
      },
    })
  }

  return (
    <Fragment>
      {!user && (
            <Button
              iconClass="fab fa-google"
              themeColor={"primary"}
              disabled={backgroundProcessor?.tasks}
              onClick={onGoogleSignOnHandler}
              style={{ color: "white" }}
            >
              {!sm || disableResize ? "Veolia Sign in" : undefined}
            </Button>
      )}

      {user && (
        <Button
          iconClass="fas fa-lock"
          style={{ color: "white" }}
          look={"flat"}
          themeColor={"primary"}
          disabled={backgroundProcessor?.tasks}
          onClick={onGoogleSignOutHandler}
        >
          {!sm || disableResize ? "Sign Out" : undefined}
        </Button>
      )}
    </Fragment>
  )
}

export default GoogleSignOn
